import { createAction } from '../../../core/helpers'

import { FETCH_DICTIONARY_WORDS } from '../action-types'

const cleanupFetchDictionaryWords = createAction(FETCH_DICTIONARY_WORDS.CLEANUP)

export default cleanupFetchDictionaryWords
